import React, { Component } from 'react';
import './index.css';

class SelectableImageRight extends Component {
  constructor(props) {
    super(props);
    this.state = {selectedIndex:0}
    this.clickHandler = this.clickHandler.bind(this);
    this.SelectableImageRightDisplay = this.SelectableImageRightDisplay.bind(this);
  }

  SelectableImageRightDisplay(){
    if (window.matchMedia('(max-width: 950px)').matches) {
      return 'none'
    } else {return''}
  }

  topLayer_JC(){
    const { lang } = this.props;
    if (window.matchMedia('(min-width: 1450px)').matches) {
      if(lang==='fa'){ return 'center' }
      else {return '' }
    } else {return''}
  }

  textSec_TA(){
    const { lang } = this.props;
    if (window.matchMedia('(max-width: 520px)').matches) {
      return 'center';
    } else {
      if(lang==='fa'){return 'right'}
      else {return 'left'}
    }
  }


  clickHandler(e, key){
    var target = e.currentTarget;
    var parent = target.parentElement;
    for(var i=0; i<parent.children.length; i++){
      var item = parent.children[i];
      if(i === key){ item.classList.add('selec-img-right-section-top-layer-list-active')}
      else{while (item.classList.length > 0){item.classList.remove(item.classList.item(0))}}
    }
    this.setState({selectedIndex:key});
  }

  render() {
    const { lang } = this.props;
    const { bgColor, title, description, textContent } = this.props.content;
    const _bgColor = bgColor ? bgColor : {leftBgClass:'bg-cream', rightBgClass:'bg-blue'};

    return (
      <div className='selec-img-right-section-container' style={{display:this.props.responsive? this.SelectableImageRightDisplay() : ''}}>
        <div className='selec-img-right-section-wrapper'>
          <div className={'selec-img-right-section-left-layer ' + _bgColor.leftBgClass}></div>
          <div className={'selec-img-right-section-right-layer ' + _bgColor.rightBgClass}></div>
          <div className='selec-img-right-section-top-layer'>
            <div className='selec-img-right-section-top-layer-description' style={{justifyContent:this.topLayer_JC()}}>
              <div className='selec-img-right-section-top-layer-description-wrapper' style={{textAlign: this.textSec_TA()}}>
                <h1>{lang==='fa' ? title.fa : title.en}</h1>
                <p>{lang==='fa' ? description.fa : description.en}</p>
                <ul style={{alignItems:lang === 'en'? 'flex-start':'flex-end'}}>
                  {
                    textContent.map((item, index)=>{
                      var classes;
                      if(this.state.selectedIndex===index){ classes='selec-img-right-section-top-layer-list-active ' } 
                      return (
                        <li key={item.text + index} onClick={(e)=>this.clickHandler(e,index)} className={classes}
                          style={{flexDirection: lang==='fa' ? 'row':'row-reverse'}}>
                          <span>{lang==='fa' ? item.text.fa:item.text.en}</span>
                          <div style={{marginLeft: lang==='fa' ? '10px':''}} className={item.bgIconClass? item.bgIconClass :'bg-red'}>
                            {item.icon ? item.icon : lang==="fa" ? '' : ''}
                          </div>
                        </li>
                      )
                    })
                  }
                </ul>
              </div>
            </div>
            <div className='selec-img-right-section-top-layer-img-wrapper'>
              {
                textContent.map((item, index)=>{
                  if(this.state.selectedIndex===index){ return (<div key={item.text + index}>{item.img}</div>) } 
                  else { return <div key={item.text + index}></div> }
                })
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}



export default SelectableImageRight;
